import React from 'react';
import { VoteButton } from './main.tsx';

export const voteIssueGroup = () => ({
	name: '',
	key: 'voteGroup',
	items: [<VoteButton key="vote" />],
});
